import {Injectable, Injector} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AuthService } from "app/+auth/auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private inj: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //AuthService has to be created this way rather than constructor, as it creats cyclic depency issue
    //https://github.com/angular/angular/issues/18224
    const authService = this.inj.get(AuthService);
    const authHeader = authService.getAuthHeader();
    console.log('req ', req);
    if (authHeader && req.url.toLowerCase().indexOf('auth/') == -1){
        console.log('>>authHeader exists. Adding to request');
        const authReq = req.clone({
          setHeaders: {Authorization: authHeader},
          headers: req.headers.set('Cache-Control', 'no-cache')
          .set('Pragma', 'no-cache')
          .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
          .set('If-Modified-Since', '0')
        });
        return next.handle(authReq);
    } else {
        console.log('>>authHeader does not exist');
        return next.handle(req);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/interceptors/auth.interceptor.ts